import {
  Backdrop,
  Box,
  CircularProgress,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useState } from "react";
import AuthLayout from "../../layout/AuthLayout";
import { colors } from "../../theme/theme";
import {
  CustomInput,
  CustomPasswordInput,
} from "../../components/Common/CustomInput";
import {
  EmailOutlined,
  PersonOutlined,
  PhoneAndroidOutlined,
} from "@mui/icons-material";
import { CustomBtn } from "../../components/Common/CustomBtn";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/config/config";
import { ErrorSnackbar } from "../../components/Common/CustomSnackbar";
import { useDispatch } from "react-redux";
import {
  getUserById,
  setAuthenticationState,
} from "../../redux/dispatchers/users.dispatcher";

const SignUp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const smScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const mdScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    password: "",
  });

  const handleChange = (e, name) => {
    const { value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const [loading, setLoading] = useState(false);
  const [errorState, setErrorState] = useState({
    error: false,
    errorMsg: "",
  });

  const handleSignUp = async () => {
    setErrorState({
      error: false,
      errorMsg: "",
    });

    if (
      !formData.email ||
      !formData.password ||
      !formData.firstName ||
      !formData.lastName
    ) {
      setErrorState({
        error: true,
        errorMsg: "Please fill all the fields",
      });
      return;
    }
    try {
      setLoading(true);
      const response = await axiosInstance.post("/user/signup", {
        firstName: formData.firstName,
        lastName: formData.lastName,
        mobile: formData.phone,
        email: formData.email,
        password: formData.password,
        role: "user",
        status: "active",
      });

      if (response.status === 200) {
        setLoading(false);
        dispatch(setAuthenticationState(true));
        dispatch(getUserById());
      }
    } catch (error) {
      console.log(error?.response?.data?.message, "error in signup");
      setErrorState({
        error: true,
        errorMsg:
          error?.response?.data?.message ||
          "Something went wrong. Please try again.",
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, errorMsg: "" })}
        errorMsg={errorState.errorMsg}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Typography
          sx={{
            color: colors.primary,
            fontSize: "28px",
            fontFamily: "Mulish-ExtraBold",
            textAlign: "center",
          }}
        >
          Join the Community
        </Typography>
        <Typography
          sx={{
            color: colors.primary,
            fontSize: "14px",
            fontFamily: "Mulish-SemiBold",
          }}
        >
          Enter the detail below
        </Typography>

        <Box sx={{ width: "100%", mt: 2 }}>
          <Stack
            direction={smScreen ? "column" : "row"}
            alignItems={"center"}
            gap={2}
          >
            <CustomInput
              label="First Name"
              placeholder="e.g., William"
              Icon={PersonOutlined}
              width={"100%"}
              value={formData.firstName}
              handleChange={(e) => handleChange(e, "firstName")}
            />
            <CustomInput
              label="Last Name"
              placeholder="e.g., Marshal"
              Icon={PersonOutlined}
              width={"100%"}
              value={formData.lastName}
              handleChange={(e) => handleChange(e, "lastName")}
            />
          </Stack>
          <CustomInput
            label="Phone no"
            placeholder="e.g., 567 876 6789"
            Icon={PhoneAndroidOutlined}
            type={"number"}
            width={"100%"}
            mT={2}
            value={formData.phone}
            handleChange={(e) => handleChange(e, "phone")}
          />
          <CustomInput
            label="Email address"
            placeholder="e.g., hello@imzul.com"
            type={"email"}
            Icon={EmailOutlined}
            width={"100%"}
            mT={2}
            value={formData.email}
            handleChange={(e) => handleChange(e, "email")}
          />
          <CustomPasswordInput
            label="Password"
            placeholder="e.g., ********"
            width={"100%"}
            mT={2}
            value={formData.password}
            handleChange={(e) => handleChange(e, "password")}
          />

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              mt: 4,
              gap: 2,
            }}
          >
            <CustomBtn
              width={smScreen ? "100%" : mdScreen ? "75%" : "40%"}
              text="Sign Up"
              icon
              fontSize={"16px"}
              onClick={handleSignUp}
            />

            <Typography
              sx={{
                color: colors.primary,
                fontFamily: "Mulish-Regular",
                fontSize: "12px",
              }}
            >
              Already have an account?{" "}
              <Typography
                component={"span"}
                sx={{
                  color: colors.secondary,
                  fontFamily: "Mulish-Bold",
                  fontSize: "12px",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={() => navigate("/sign-in")}
              >
                Sign In
              </Typography>
            </Typography>
          </Box>
        </Box>
      </Box>
    </AuthLayout>
  );
};

export default SignUp;
